import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const SAFE_REDIRECT_URL_PARAM = 'sruri';

export function SafeRedirect() {
    const location = useLocation();

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const url = decodeURIComponent(urlParams.get(SAFE_REDIRECT_URL_PARAM) ?? '');

        if (url) {
            window.open(url, '_self');
        }
    });

    return null;
}
